<template>
	<div class="loading">
		<van-loading size="24px" type="spinner" vertical>加载中</van-loading>
		<van-button type="default" round size="mini" @click="reset">亲~请点击再次刷新</van-button>
	</div>
</template>

<script>
	export default {
		name: 'loding',
		data() {
			return {

			}
		},
		methods: {
			reset() {
				this.$router.go(0)
			}
		}
	}
</script>

<style scoped>
	.loading {
		padding-top: 13rem;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}

	.loading .van-button {
		padding: 0 1rem;
		margin-top: 1rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/loding.vue